import { useTour } from '@reactour/tour'
import { GuidedTourIcon } from 'assets/icons'
import { MenuContactIcon, MenuUserGuideIcon } from 'assets/icons/menu'
import BrowserDialog from 'components/dialogs/BrwoserDialog'
import {
  ONBOARDING_MODE,
  useTfmTourProvider
} from 'components/onboarding/TFMTourProvider'
import PopupSection from 'components/popup/PopupSection'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import i18n from 'i18n'
import { t } from 'i18next'
import { useState } from 'react'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import UAParser from 'ua-parser-js'
import { is24meApp, isGroupcalApp } from 'utils/appType'
import { sendEmailToUs } from 'utils/env'
import { SUPPORT_EMAIL, SUPPORT_EMAIL_TFM } from 'utils/strings'

export interface HelpCenterSectionProps {
  setPopupOpen: (b: boolean) => void
}

export default function HelpCenterSection(props: HelpCenterSectionProps) {
  const onContactUs = () => {
    sendEmailToUs()
    props.setPopupOpen(false)
  }

  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep, setSteps } =
    useTour()

  const tfmTour = useTfmTourProvider()

  const onGuidedTour = () => {
    LocalStorage.set(LocalStorageKey.USER_FINSHED_ONBOARDING, '0')
    LocalStorage.remove(LocalStorageKey.STATE_DICT)

    tfmTour.setMode(ONBOARDING_MODE.FIRST_LOGIN)

    if (setSteps && tfmTour.getStepsByMode) {
      setSteps(tfmTour.getStepsByMode(ONBOARDING_MODE.FIRST_LOGIN))
    }
    setCurrentStep(0)
    setIsOpen(true)

    props.setPopupOpen(false)
  }

  return (
    <PopupSection title={`${t('helpCenter')}`}>
      <PopupSectionRow
        icon={<GuidedTourIcon />}
        title={t('guidedTour')}
        iconClass="icon-regular"
        maxWidthIcon={20}
        onlyTitle
        action={onGuidedTour}
      />
      <PopupSectionRow
        icon={<MenuContactIcon />}
        title={t('contactUs')}
        iconClass="icon-regular"
        maxWidthIcon={20}
        onlyTitle
        action={onContactUs}
      />
      <PopupSectionRow
        title={t('userGuide')}
        icon={<MenuUserGuideIcon />}
        iconClass="icon-regular"
        maxWidthIcon={20}
        action={() => {
          window.open(
            is24meApp()
              ? 'https://24me.zendesk.com/'
              : 'https://www.groupcal.app/guide/',
            '_blank'
          )
        }}
      />
    </PopupSection>
  )
}
